import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AuthService } from "projects/shared/services/auth.service";
import { RegionalActions } from "./regional-setting.actions";
import { filter, switchMap, map, catchError, of, withLatestFrom } from "rxjs";
import { SelectRegionalLanguage, SelectRegionalSettings } from "./regional-setting.selectors";

@Injectable()
export class RegionalSettingEffects {
  actions$ = inject(Actions);
  store = inject(Store);
  authService = inject(AuthService);
  language$ = this.store.selectSignal(SelectRegionalLanguage)

  RegionalEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionalActions.initialize),
      withLatestFrom(this.store.select(SelectRegionalSettings)),
      filter(([action, settings]) => !settings?.country),
      switchMap(([action]) =>
        this.authService.getSuggestLanguage().pipe(
          map(res => RegionalActions.loadData({
            country: res.country,
            currency: res.suggestedCurrency,
            language: this.language$() ?? res.suggestedLanguage
          })),
        )
      )
    )
  );
}